/**
 * 
 * @param {Number} index 
 * @param {HTML} element 
 */
function ProductLinks( index, element ) {
    this.$element = $( element );

    this.selectors = {
        anchor : ".product-links__item a",
        image : ".product-links__image"
    }

    this.init();
}

ProductLinks.prototype = Object.assign( {}, ProductLinks.prototype, {
    init: function() {
        this.$anchor = this.$element.find( this.selectors.anchor );
        this.$image = this.$element.find( this.selectors.image );
        this.$anchor.on( "mouseover", this._handleAnchorHover.bind( this ) );
    },
    _handleAnchorHover: function( event ) {
        var index = $( event.currentTarget ).data( "index" );
        var imgUrl = $( event.currentTarget ).data( "main-image" );
        var imageElement = this.$element.find( this.selectors.image + "[data-index='" + index + "']");
        
        this.assignActiveClass( imageElement );
    },
    assignActiveClass: function( imageElement ) {
        this.$image.removeClass( "is-active" );
        imageElement.addClass( "is-active" );
    }
} );